export default "__VITE_ASSET__DqEfRmI6__"